import styled, { css } from 'styled-components'

import { isDesktop } from 'utils/device'

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background: white;
    position: relative;

    ${!isDesktop &&
        css`
            width: 50px;
            height: 50px;
        `}
`

export const ButtonIcon = styled.img`
    display: flex;
    width: 20px;
    height: 20px;

    ${!isDesktop &&
        css`
            width: 25px;
            height: 25px;
        `}
`

export const Badge = styled.span`
    position: absolute;
    background-color: red;
    font-weight: normal;
    font-size: 10px;
    line-height: 20px;
    height: 20px;
    width: 20px;
    letter-spacing: 0.01em;
    color: #ffffff;
    border-radius: 50%;
    text-align: center;
    left: 60%;
    bottom: 60%;
`
